module.exports = __webpack_public_path__ + "static/media/icon_infinity.951c5bd2.svg";